// extracted by mini-css-extract-plugin
export default {"pinchIcon":"canvas-zoom-pinch-onboarding-module__pinchIcon--zld40","tooltip":"canvas-zoom-pinch-onboarding-module__tooltip--YbG5K"};